import { render, staticRenderFns } from "./assignmentDescription.html?vue&type=template&id=498c5580&scoped=true&"
import script from "./assignmentDescription.js?vue&type=script&lang=js&"
export * from "./assignmentDescription.js?vue&type=script&lang=js&"
import style0 from "./assignmentDescription.css?vue&type=style&index=0&id=498c5580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c5580",
  null
  
)

export default component.exports